module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/logo3.8d3dd9e5.png";